import { css } from '@emotion/react';
import React, { Fragment } from 'react';
import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { getAddressFromLatLng, moveMarker } from '../../../_helpers';
import GoogleMap from '../GoogleMap';

function HomeLocationComponent({ formInput, formLabel, location, register, setValue, currentMarker }) {
    const fieldName = `addresses[0]`;
    const locationName = `${fieldName}.location`;
    const latName = `${fieldName}.latitude`;
    const longName = `${fieldName}.longitude`;
    useEffect(() => {
        getAddressFromLatLng(location.latitude, location.longitude, locationName, latName, longName, setValue);
    }, [latName, location.latitude, location.longitude, locationName, longName, setValue]);
    let isDraggable = true;
    return (
        <Fragment>
            <Form.Group controlId="formBasicTitle">
                <Form.Label css={formLabel}>Location</Form.Label>
                <Form.Control css={formInput} type="text" name={locationName} ref={register} readOnly />
                <input ref={register} name={latName} readOnly hidden />
                <input ref={register} name={longName} readOnly hidden />
            </Form.Group>
            <div
                css={css`
                    width: 100%;
                    height: 350px;
                    position: relative;
                    overflow-y: auto;
                `}
            >
                <GoogleMap
                    lat={Number(location?.latitude)}
                    lng={Number(location?.longitude)}
                    draggable={isDraggable}
                    onDragend={(t, map, coord) => moveMarker(t, map, coord, locationName, latName, longName, setValue)}
                    showPublicChannels={false}
                    currentMarker={currentMarker}
                />
            </div>
        </Fragment>
    );
}

export default HomeLocationComponent;
